import React from 'react';

import { Divider, Group, Paper, ScrollArea, Stack, Title } from '@mantine/core';
import { DroxyBadge } from 'components/Droxy/DroxyBadge';
import { EvaluationTestNavigationItem } from 'pages/ManageSmartAssistant/Sections/EvaluationsSection/EvaluationView/EvaluationTestNavigationItem';
import { useTranslation } from 'react-i18next';
import { EvaluationTest } from 'shared/interfaces/Evaluation';

interface EvaluationTestsListProps {
  evaluationTests: EvaluationTest[];
  setSelectedTestId: (testId: string) => void;
  selectedTestId: string | null;
}

export function EvaluationTestsList({ evaluationTests, setSelectedTestId, selectedTestId }: EvaluationTestsListProps) {
  const { t } = useTranslation();

  return (
    <Paper withBorder radius="md" maw={350} miw={250} h="100%" sx={{ overflow: 'hidden' }}>
      <Stack h="100%" spacing={0}>
        <Group position="apart" mb="xs" px="md" pt="md">
          <Title order={4} fw={600}>
            {t('SMART_ASSISTANT.EVALUATIONS_SECTION.TESTS_LIST.TITLE')}
          </Title>
          <DroxyBadge>
            {t('SMART_ASSISTANT.EVALUATIONS_SECTION.TESTS_LIST.NUMBER_OF_TESTS', {
              count: evaluationTests.length
            })}
          </DroxyBadge>
        </Group>

        <Divider color="gray.2" py={0} my={0} />

        <ScrollArea
          type="auto"
          offsetScrollbars
          scrollbarSize={0}
          style={{ flexGrow: 1 }}
          styles={{ viewport: { paddingRight: 0 } }}>
          <Stack spacing={0}>
            {evaluationTests.map((evaluationTest, index) => (
              <EvaluationTestNavigationItem
                key={evaluationTest._id}
                evaluationTest={evaluationTest}
                setSelectedTestId={setSelectedTestId}
                isSelected={selectedTestId === evaluationTest._id}
                isLast={index === evaluationTests.length - 1}
              />
            ))}
          </Stack>
        </ScrollArea>
      </Stack>
    </Paper>
  );
}
